import { Col, Row } from "react-bootstrap";
import { NFTextInput } from "../../../Shared/NewForms/NFTextInput";
import { NFDateInput } from "../../../Shared/NewForms/NFDateInput";
import { NFLookupCompany } from "../../../Shared/NewForms/NFLookupCompany";
import { NFLookupBankAccount } from "../../../Shared/NewForms/NFLookupBankAccount";
import { useTranslation } from "react-i18next";

const BankAcquirerDetailMain = () => {
  const { t } = useTranslation();
  return (
    <>
      <Row>
        <Col sm={6}>
          <NFTextInput title={t("Name")} fieldName={"name"} />
        </Col>
        <Col sm={3}>
          <NFTextInput title={t("UniqueCode")} fieldName={"uniqueCode"} />
        </Col>
        <Col sm={3}>
          <NFDateInput title={t("CreatedDate")} fieldName={"createdDate"} />
        </Col>
      </Row>
      <Row>
        <Col sm={6}>
          <NFLookupCompany fieldName={"companyId"} title={t("Company")} required/>
        </Col>
        <Col sm={6}>
          <NFTextInput fieldName={"terminalNumber"} title={t("TerminalNumber")} />
        </Col>
      </Row>
      <Row>
        <Col sm={6}>
          <NFLookupBankAccount fieldName={"bankAccountId"} title={t("BankAccount")} required/>
        </Col>
        <Col sm={6}>
          <NFTextInput fieldName={"acquirer"} title={t("Acquirer")} />
        </Col>
      </Row>
    </>
  );
};

export default BankAcquirerDetailMain;
